<div *ngIf="isLoading$| async" class="loading-overlay">
  <mat-spinner class="loading-spinner"></mat-spinner>
</div>
